// utilities
import "./utilities/animations";

// lightbox
require('fslightbox'); // used with the booking widget

// components
import "./components/main-navigation";
import "./components/accordion";
// import "./components/video";
import "./components/slider";
import "./components/popup";

// Before & After Gallery Slider
import "./components/bna-gallery-slider";
import "./components/bna-gallery-adult-check";

// blocks
// import "../../template-parts/blocks/video-carousel/script";
import "../../template-parts/blocks/header/script";
import "../../template-parts/blocks/hero/script";
import "../../template-parts/blocks/doctor-achievements/script";